import { SuccessTokenStepResponse, RedirectionResponse } from '@shared/services';

const TOKEN_FIELD_CHECKS: Array<(r: any) => boolean> = [
  (r) => typeof r.access_token === 'string',
  (r) => typeof r.token_type === 'string',
  (r) => typeof r.expiration_time === 'number',
  (r) => typeof r.issued_at === 'number',
  (r) => typeof r.next_step === 'string',
];

function hasRequiredTokenFields(response: any): boolean {
  return TOKEN_FIELD_CHECKS.every(check => check(response));
}

function isRedirectionShape(response: any): boolean {
  return 'location' in response && 'status_code' in response;
}

export function isSuccessTokenStepResponse(response: any): response is SuccessTokenStepResponse {
  if (!response || typeof response !== 'object') {
    return false;
  }
  
  return !isRedirectionShape(response) && hasRequiredTokenFields(response);
}

function isValidStatusCode(value: any): boolean {
  return typeof value === 'number' || typeof value === 'string';
}

export function isRedirectionResponse(response: any): response is RedirectionResponse {
  if (!response || typeof response !== 'object') {
    return false;
  }
  
  return typeof response.location === 'string' && isValidStatusCode(response.status_code);
}
